import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchWeddings,
  saveWedding,
  updateWedding,
} from "../../../redux/slices/orgAdmin/weddingsSlice";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  TextField,
  Typography,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  StyledButton,
  StyledContainer,
  StyledTableCell,
} from "../../CSS/Styles";

export default function Weddings() {
  const dispatch = useDispatch();
  const { weddings } = useSelector((state) => state.weddings);

  const [newWedding, setNewWedding] = useState({
    weddingName: "",
    weddingDate: "",
    location: "",
    names: { brideName: "", groomName: "" },
    images: [],
    bankDetails: "",
    googleMapsAddress: "",
    eventSchedule: [],
    ourStory: [""],
  });
  const [editingWedding, setEditingWedding] = useState(null);
  const [isFormVisible, setIsFormVisible] = useState(false);

  useEffect(() => {
    if (!weddings?.length) {
      dispatch(fetchWeddings());
    }
  }, [dispatch, weddings]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewWedding((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleNestedInputChange = (e, parentKey) => {
    const { name, value } = e.target;
    setNewWedding((prevState) => ({
      ...prevState,
      [parentKey]: { ...prevState[parentKey], [name]: value },
    }));
  };

  const handleOurStoryChange = (index, value) => {
    const updatedStory = [...newWedding.ourStory];
    updatedStory[index] = value;
    setNewWedding((prev) => ({ ...prev, ourStory: updatedStory }));
  };

  const addStoryEvent = () => {
    setNewWedding((prev) => ({ ...prev, ourStory: [...prev.ourStory, ""] }));
  };

  const removeStoryEvent = (index) => {
    setNewWedding((prev) => ({
      ...prev,
      ourStory: prev.ourStory.filter((_, i) => i !== index),
    }));
  };

  return (
    <StyledContainer>
      <Paper elevation={3} sx={{ padding: 3 }}>
        {!isFormVisible && (
          <StyledButton
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={() => setIsFormVisible(true)}
          >
            Create Wedding
          </StyledButton>
        )}

        {isFormVisible && (
          <Box mt={3} display="flex" flexDirection="column" gap={2}>
            <Box display="flex" alignItems="center" gap={1} mb={2}>
              <IconButton onClick={() => setIsFormVisible(false)}>
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="h6">Create Wedding</Typography>
            </Box>
            <TextField
              label="Wedding Name"
              name="weddingName"
              value={newWedding.weddingName}
              onChange={handleInputChange}
              fullWidth
            />
            <TextField
              name="weddingDate"
              type="datetime-local"
              value={newWedding.weddingDate}
              onChange={handleInputChange}
              fullWidth
            />
            <TextField
              label="Location"
              name="location"
              value={newWedding.location}
              onChange={handleInputChange}
              fullWidth
            />
            <Box display="flex" gap={2}>
              <TextField
                label="Bride Name"
                name="brideName"
                value={newWedding.names.brideName}
                onChange={(e) => handleNestedInputChange(e, "names")}
                fullWidth
              />
              <TextField
                label="Groom Name"
                name="groomName"
                value={newWedding.names.groomName}
                onChange={(e) => handleNestedInputChange(e, "names")}
                fullWidth
              />
            </Box>
            <TextField
              label="Bank Details"
              name="bankDetails"
              value={newWedding.bankDetails}
              onChange={handleInputChange}
              fullWidth
            />
            <TextField
              label="Google Maps Address"
              name="googleMapsAddress"
              value={newWedding.googleMapsAddress}
              onChange={handleInputChange}
              fullWidth
            />

            <Typography variant="subtitle1">Our Story</Typography>
            {newWedding.ourStory.map((story, index) => (
              <Box key={index} display="flex" gap={1} alignItems="center">
                <TextField
                  label={`Event ${index + 1}`}
                  value={story}
                  onChange={(e) => handleOurStoryChange(index, e.target.value)}
                  fullWidth
                />
                <IconButton
                  onClick={() => removeStoryEvent(index)}
                  disabled={newWedding.ourStory.length === 1}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            ))}
            <Button startIcon={<AddIcon />} onClick={addStoryEvent}>
              Add Event
            </Button>

            <Button
              sx={{ backgroundColor: "#162036", mt: 3 }}
              component="label"
              variant="contained"
              startIcon={<CloudUploadIcon />}
            >
              Upload Attachment
              <input
                type="file"
                hidden
                multiple
                onChange={(e) =>
                  setNewWedding((prev) => ({
                    ...prev,
                    images: [...prev.images, ...Array.from(e.target.files)],
                  }))
                }
              />
            </Button>
          </Box>
        )}
      </Paper>
    </StyledContainer>
  );
}
